__turbopack_context__.v({
  "section-certificate": "_5TDZZq_section-certificate",
  "section-certificate__container": "_5TDZZq_section-certificate__container",
  "section-certificate__text": "_5TDZZq_section-certificate__text",
});
